import { createContext } from 'react';
import { AddressFieldNames } from './address-form.component';
import {
  usePlace,
  UsePlaceOptions,
  UsePlaceReturnValue,
} from './address-form.hooks';

export const AddressFormContext = createContext<{
  placeContext?: UsePlaceReturnValue;
  fieldNames?: AddressFieldNames;
}>({});

type AddressFormProviderProps = {
  fieldNames: any;
  usePlaceOptions?: UsePlaceOptions;
  children: React.ReactNode;
};

const AddressFormProvider = ({
  fieldNames,
  usePlaceOptions,
  children,
}: AddressFormProviderProps) => {
  const placeContext = usePlace(usePlaceOptions);

  return (
    <AddressFormContext.Provider value={{ placeContext, fieldNames }}>
      {children}
    </AddressFormContext.Provider>
  );
};

export default AddressFormProvider;
